import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["line", "subtotal", "hint", "submit", "total"]

  connect() {
    this.refresh()
  }

  validate(event) {
    if (this.totalQty === 0) event.preventDefault()
  }

  refresh() {
    const qty = this.totalQty
    const cents = this.totalCents
    const formatted = this.formatCents(cents)

    if (this.hasSubtotalTarget) {
      this.subtotalTarget.textContent = `${qty} ingresso(s) · ${formatted}`
    }
    if (this.hasTotalTarget) this.totalTarget.textContent = formatted

    const empty = qty === 0
    if (this.hasHintTarget) this.hintTarget.hidden = !empty
    this.submitTargets.forEach((button) => { button.disabled = empty })
  }

  get totalQty() {
    return this.lineTargets.reduce((sum, line) => sum + this.lineQty(line), 0)
  }

  get totalCents() {
    return this.lineTargets.reduce((sum, line) => {
      const price = parseInt(line.dataset.ticketLinePriceValue || "0", 10)
      return sum + price * this.lineQty(line)
    }, 0)
  }

  lineQty(line) {
    const input = line.querySelector("[data-ticket-line-target='input']")
    return parseInt(input?.value || "0", 10)
  }

  formatCents(cents) {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format((cents || 0) / 100)
  }
}
